function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 8.45,
    y1: 788.210022,
    x2: 122.239998,
    y2: 742.210022,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(10.980392%,73.333333%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(12.156863%,60%,64.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "rgb(12.54902%,61.176471%,65.098039%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(14.117647%,64.313725%,66.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "rgb(16.862745%,70.196078%,69.019608%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "rgb(18.823529%,74.117647%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(21.960784%,72.941176%,56.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(37.647059%,94.117647%,35.294118%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: -697.099976,
    cy: 260.220001,
    fx: -697.099976,
    fy: 260.220001,
    r: 0.76,
    gradientTransform: "matrix(2.553098,9.09512,-6.912804,1.940498,3589.805208,5844.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.811765
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: -696.080017,
    cy: 252.929993,
    fx: -696.080017,
    fy: 252.929993,
    r: 0.76,
    gradientTransform: "matrix(-0.128207,6.386713,-4.853689,-0.097433,1151.051953,4478.831771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.698039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: -694.919983,
    cy: 251.429993,
    fx: -694.919983,
    fy: 251.429993,
    r: 0.76,
    gradientTransform: "matrix(0.145486,5.952889,-4.226738,0.103299,1176.017318,4119.422656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.898039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.0588235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: -692.51001,
    cy: 247.669998,
    fx: -692.51001,
    fy: 247.669998,
    r: 0.76,
    gradientTransform: "matrix(0.11747,4.806565,-3.412314,0.0833953,938.913346,3316.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0.631373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    gradientUnits: "userSpaceOnUse",
    cx: -689.349976,
    cy: 240.050003,
    fx: -689.349976,
    fy: 240.050003,
    r: 0.76,
    gradientTransform: "matrix(0.0936894,3.833522,-2.453934,0.0599729,665.929362,2636.841406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.54902%,45.098039%,35.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "rgb(12.54902%,45.490196%,35.294118%)",
      stopOpacity: 0.929412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(12.941176%,45.882353%,36.078431%)",
      stopOpacity: 0.741176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(12.941176%,47.058824%,36.470588%)",
      stopOpacity: 0.431373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(13.333333%,48.235294%,37.647059%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial5",
    gradientUnits: "userSpaceOnUse",
    cx: -691.109985,
    cy: 272.779999,
    fx: -691.109985,
    fy: 272.779999,
    r: 0.76,
    gradientTransform: "matrix(5.645911,2.490143,-1.867608,4.234433,4424.216146,574.824023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.333333%,47.843137%,38.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(13.333333%,47.843137%,38.039216%)",
      stopOpacity: 0.560784
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "rgb(13.333333%,47.843137%,38.039216%)",
      stopOpacity: 0.160784
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(13.333333%,47.843137%,38.039216%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial6",
    gradientUnits: "userSpaceOnUse",
    cx: -693.960022,
    cy: 268.5,
    fx: -693.960022,
    fy: 268.5,
    r: 0.76,
    gradientTransform: "matrix(6.718757,4.751866,-4.344585,6.142895,5840.214583,1650.078646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(23.529412%,85.098039%,76.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "rgb(23.137255%,84.313725%,75.686275%)",
      stopOpacity: 0.898039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "rgb(21.960784%,80.784314%,72.54902%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "rgb(21.176471%,78.431373%,70.588235%)",
      stopOpacity: 0.121569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "rgb(20.784314%,77.647059%,69.803922%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial7",
    gradientUnits: "userSpaceOnUse",
    cx: -702.98999,
    cy: 267.019989,
    fx: -702.98999,
    fy: 267.019989,
    r: 0.76,
    gradientTransform: "matrix(1193.450256,844.072087,-592.166235,837.275578,989186,364979.733333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(23.529412%,85.098039%,76.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "rgb(23.137255%,84.313725%,75.686275%)",
      stopOpacity: 0.898039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "rgb(21.960784%,80.784314%,72.54902%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "rgb(21.176471%,78.431373%,70.588235%)",
      stopOpacity: 0.121569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "rgb(20.784314%,77.647059%,69.803922%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial8",
    gradientUnits: "userSpaceOnUse",
    cx: -698.950012,
    cy: 258.549988,
    fx: -698.950012,
    fy: 258.549988,
    r: 0.76,
    gradientTransform: "matrix(-1.381034,7.12472,-8.805436,-1.706819,1324.674609,5431.657292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(13.72549%,49.803922%,40%)",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(17.254902%,54.901961%,43.921569%)",
      stopOpacity: 0.65098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(23.921569%,65.490196%,52.156863%)",
      stopOpacity: 0.368627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "rgb(29.019608%,72.941176%,57.647059%)",
      stopOpacity: 0.168627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(31.764706%,77.254902%,61.176471%)",
      stopOpacity: 0.0392157
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "rgb(32.941176%,78.823529%,62.352941%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial9",
    gradientUnits: "userSpaceOnUse",
    cx: -705.150024,
    cy: 275.950012,
    fx: -705.150024,
    fy: 275.950012,
    r: 0.76,
    gradientTransform: "matrix(5.9916,-7.351665,7.939757,6.470894,2044.6,-6959.069271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,48.627451%,54.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "rgb(8.627451%,48.627451%,54.117647%)",
      stopOpacity: 0.929412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(9.019608%,49.803922%,55.294118%)",
      stopOpacity: 0.431373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,56.078431%)",
      stopOpacity: 0.121569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial10",
    gradientUnits: "userSpaceOnUse",
    cx: -701.940002,
    cy: 278.839996,
    fx: -701.940002,
    fy: 278.839996,
    r: 0.77,
    gradientTransform: "matrix(7.875096,-4.856167,3.836505,6.221542,4468.125521,-5132.311979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "rgb(9.019608%,49.019608%,52.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "rgb(9.019608%,49.411765%,53.72549%)",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(9.019608%,49.803922%,54.509804%)",
      stopOpacity: 0.521569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,55.294118%)",
      stopOpacity: 0.290196
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,56.078431%)",
      stopOpacity: 0.129412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0.0313725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial11",
    gradientUnits: "userSpaceOnUse",
    cx: -721.099976,
    cy: 270.700012,
    fx: -721.099976,
    fy: 270.700012,
    r: 0.76,
    gradientTransform: "matrix(-3.582682,-4.188858,3.298194,-2.820907,-3467.991927,-2245.805208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(9.019608%,49.803922%,54.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(9.019608%,49.803922%,54.117647%)",
      stopOpacity: 0.980392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(9.019608%,50.196078%,54.901961%)",
      stopOpacity: 0.678431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,55.294118%)",
      stopOpacity: 0.431373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,56.078431%)",
      stopOpacity: 0.239216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.078431%)",
      stopOpacity: 0.109804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0.0313725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial12",
    gradientUnits: "userSpaceOnUse",
    cx: -719.679993,
    cy: 257.839996,
    fx: -719.679993,
    fy: 257.839996,
    r: 0.76,
    gradientTransform: "matrix(-5.133325,-0.620292,0.620292,-5.133325,-3846.714583,889.796029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,39.607843%,43.137255%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "rgb(7.45098%,39.215686%,43.137255%)",
      stopOpacity: 0.729412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(7.058824%,39.215686%,43.137255%)",
      stopOpacity: 0.411765
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "rgb(7.058824%,38.823529%,43.137255%)",
      stopOpacity: 0.180392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "rgb(7.058824%,38.823529%,43.137255%)",
      stopOpacity: 0.0509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "rgb(7.058824%,38.823529%,43.137255%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial13",
    gradientUnits: "userSpaceOnUse",
    cx: -728.169983,
    cy: 277.950012,
    fx: -728.169983,
    fy: 277.950012,
    r: 0.77,
    gradientTransform: "matrix(-1.770708,-3.152785,2.648246,-1.487342,-2017.917318,-1869.335938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(7.843137%,41.568627%,45.098039%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(8.235294%,43.529412%,47.45098%)",
      stopOpacity: 0.788235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "rgb(8.627451%,46.666667%,51.372549%)",
      stopOpacity: 0.45098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "rgb(8.627451%,49.019608%,54.117647%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "rgb(9.019608%,50.588235%,55.686275%)",
      stopOpacity: 0.0509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "rgb(9.019608%,50.980392%,56.470588%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial14",
    gradientUnits: "userSpaceOnUse",
    cx: -707.52002,
    cy: 300.519989,
    fx: -707.52002,
    fy: 300.519989,
    r: 0.76,
    gradientTransform: "matrix(1.902494,-2.819501,2.233717,1.507228,682.021354,-2436.133333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 0.870588
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 0.501961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 0.0588235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(9.803922%,55.686275%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 16.120001,
    y1: 715.219971,
    x2: 66.150002,
    y2: 761.52002,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(16.862745%,97.647059%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(16.078431%,97.647059%,100%)",
      stopOpacity: 0.639216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(15.294118%,98.039216%,100%)",
      stopOpacity: 0.301961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0.0784314
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: -12.31,
    y1: 790.799988,
    x2: 46.099998,
    y2: 774.22998,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0.878431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0.509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0.0588235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "rgb(14.901961%,98.039216%,100%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 2.96,
    y1: 788.840027,
    x2: 68.959999,
    y2: 765.320007,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.878431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.0588235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 65.889999,
    y1: 754.710022,
    x2: 102.720001,
    y2: 814.780029,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.0588235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.231373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 0.878431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.941176%,87.058824%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 106.889999,
    y1: 777.169983,
    x2: 101.110001,
    y2: 748.950012,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0.521569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0.290196
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0.129412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0.0313725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "rgb(26.666667%,69.019608%,26.666667%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 26.040001,
    y1: 747.950012,
    x2: 147.899994,
    y2: 788.299988,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(18.823529%,40%,98.431373%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(18.431373%,39.215686%,96.862745%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(15.686275%,34.117647%,85.098039%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(23.529412%,49.411765%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial15",
    gradientUnits: "userSpaceOnUse",
    cx: -700.849976,
    cy: 257.149994,
    fx: -700.849976,
    fy: 257.149994,
    r: 0.76,
    gradientTransform: "matrix(-1.717572,11.237499,-7.416538,-1.133565,718.342643,8176.864062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial16",
    gradientUnits: "userSpaceOnUse",
    cx: -703.320007,
    cy: 266.589996,
    fx: -703.320007,
    fy: 266.589996,
    r: 0.76,
    gradientTransform: "matrix(-211.336324,1382.702632,-745.282304,-113.911132,49997.629167,995245.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial17",
    gradientUnits: "userSpaceOnUse",
    cx: -703.559998,
    cy: 266.700012,
    fx: -703.559998,
    fy: 266.700012,
    r: 0.76,
    gradientTransform: "matrix(-249.678976,1647.036099,-680.188909,-103.111808,6150.150521,1178621.733333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial18",
    gradientUnits: "userSpaceOnUse",
    cx: -698.380005,
    cy: 258.51001,
    fx: -698.380005,
    fy: 258.51001,
    r: 0.76,
    gradientTransform: "matrix(1.195402,9.863828,-6.882972,0.834151,2628.170573,6682.757292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.690196
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.180392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial19",
    gradientUnits: "userSpaceOnUse",
    cx: -697.299988,
    cy: 259.559998,
    fx: -697.299988,
    fy: 259.559998,
    r: 0.76,
    gradientTransform: "matrix(2.529456,9.208237,-6.261395,1.719974,3404.222656,5984.928125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(9.411765%,21.960784%,56.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "rgb(9.803922%,23.137255%,58.823529%)",
      stopOpacity: 0.45098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial20",
    gradientUnits: "userSpaceOnUse",
    cx: -688.559998,
    cy: 255.360001,
    fx: -688.559998,
    fy: 255.360001,
    r: 0.76,
    gradientTransform: "matrix(1.17608,4.281406,-4.066692,1.1171,1862.920052,2675.077344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(9.411765%,21.960784%,56.078431%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "rgb(9.411765%,22.352941%,57.254902%)",
      stopOpacity: 0.780392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "rgb(9.803922%,23.137255%,58.823529%)",
      stopOpacity: 0.501961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "rgb(9.803922%,23.529412%,59.607843%)",
      stopOpacity: 0.278431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(10.196078%,23.529412%,60.392157%)",
      stopOpacity: 0.129412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0313725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial21",
    gradientUnits: "userSpaceOnUse",
    cx: -688.599976,
    cy: 255.360001,
    fx: -688.599976,
    fy: 255.360001,
    r: 0.76,
    gradientTransform: "matrix(1.17608,4.281406,-4.066692,1.1171,1863.026693,2675.835938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.780392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.45098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0509804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial22",
    gradientUnits: "userSpaceOnUse",
    cx: -697.409973,
    cy: 261.209991,
    fx: -697.409973,
    fy: 261.209991,
    r: 0.76,
    gradientTransform: "matrix(4.13508,9.755836,-6.474428,2.744232,4581.022917,6097.841146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.560784
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.431373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.121569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial23",
    gradientUnits: "userSpaceOnUse",
    cx: -695.659973,
    cy: 256.75,
    fx: -695.659973,
    fy: 256.75,
    r: 0.76,
    gradientTransform: "matrix(1.888193,7.629832,-5.037371,1.246623,2611.861458,4996.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.878431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.611765
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.388235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.219608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0196078
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial24",
    gradientUnits: "userSpaceOnUse",
    cx: -695.659973,
    cy: 256.75,
    fx: -695.659973,
    fy: 256.75,
    r: 0.76,
    gradientTransform: "matrix(1.888193,7.629832,-5.037371,1.246623,2611.861458,4996.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(10.588235%,24.313725%,61.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(10.588235%,24.313725%,61.960784%)",
      stopOpacity: 0.870588
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(10.588235%,24.313725%,61.568627%)",
      stopOpacity: 0.611765
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.568627%)",
      stopOpacity: 0.388235
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.219608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0196078
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial25",
    gradientUnits: "userSpaceOnUse",
    cx: -692.77002,
    cy: 253.570007,
    fx: -692.77002,
    fy: 253.570007,
    r: 0.76,
    gradientTransform: "matrix(1.444571,5.837242,-3.853097,0.953545,1983.274609,3810.269271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(9.411765%,22.352941%,56.862745%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "rgb(9.411765%,22.352941%,57.254902%)",
      stopOpacity: 0.94902
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(9.803922%,22.745098%,58.431373%)",
      stopOpacity: 0.658824
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "rgb(9.803922%,23.137255%,59.215686%)",
      stopOpacity: 0.419608
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(10.196078%,23.529412%,60%)",
      stopOpacity: 0.239216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,60.784314%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0.0313725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(10.196078%,23.921569%,61.176471%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial26",
    gradientUnits: "userSpaceOnUse",
    cx: -692.030029,
    cy: 251.220001,
    fx: -692.030029,
    fy: 251.220001,
    r: 0.76,
    gradientTransform: "matrix(0.237038,4.74475,-4.177457,0.208697,1220.409375,3240.606771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "rgb(14.117647%,32.54902%,83.921569%)",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "rgb(14.117647%,32.54902%,83.921569%)",
      stopOpacity: 0.490196
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "rgb(14.117647%,32.54902%,83.921569%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "rgb(14.117647%,32.54902%,83.921569%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 105.260002,
    y1: 698.130005,
    x2: 74.459999,
    y2: 774.25,
    gradientTransform: "matrix(0.133333,0,0,0.133333,0,-92.558667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(21.568627%,45.490196%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "rgb(21.568627%,45.490196%,100%)",
      stopOpacity: 0.909804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "rgb(21.568627%,45.490196%,100%)",
      stopOpacity: 0.658824
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "rgb(21.568627%,45.490196%,100%)",
      stopOpacity: 0.278431
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "rgb(21.568627%,45.490196%,100%)",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial1)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial2)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial3)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial4)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial5)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial6)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial7)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial8)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial9)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial10)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial11)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial12)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial13)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial14)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 4.738281 10.144531 C 5.628906 13.101562 6.914062 14.933594 7.910156 10.703125 C 7.816406 10.6875 9.933594 5.089844 10.019531 4.871094 C 10.835938 3.785156 12.152344 3.117188 13.515625 3.128906 C 16.214844 2.921875 19.011719 6.660156 18.277344 8.46875 C 17.777344 9.78125 15.890625 10.058594 15.023438 8.960938 C 14.722656 8.585938 14.605469 8.109375 14.34375 7.695312 C 13.839844 6.757812 13.171875 6.664062 12.742188 7.714844 C 12.382812 8.5 12.191406 9.316406 12 10.140625 L 11.183594 12.792969 L 10.042969 15.308594 C 9.222656 16.375 7.925781 17.011719 6.585938 17.019531 C 1.230469 16.757812 0.765625 9.621094 0.335938 7.472656 C 0.277344 6.878906 0.332031 6.601562 0.582031 6.136719 C 1.238281 4.976562 3.054688 4.914062 3.800781 6.011719 C 4.066406 6.378906 4.117188 6.847656 4.167969 7.289062 C 4.28125 8.246094 4.476562 9.203125 4.738281 10.144531 Z M 4.738281 10.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 8.765625 8.195312 L 10.019531 4.863281 C 11.40625 2.941406 14.371094 2.527344 16.207031 4.046875 C 17.492188 5.015625 18.257812 6.933594 18.257812 6.933594 C 18.582031 7.632812 18.414062 8.546875 17.859375 9.082031 C 17.097656 9.875 15.714844 9.804688 15.023438 8.949219 C 14.570312 8.445312 14.167969 6.554688 13.222656 7.023438 C 12.511719 7.726562 12.359375 8.820312 12.089844 9.734375 C 12.085938 9.914062 11.253906 12.535156 11.183594 12.785156 L 8.765625 8.199219 Z M 8.765625 8.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.347656 6.820312 18.371094 7.726562 C 18.417969 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.117188 6.441406 4.167969 7.296875 C 4.226562 8.261719 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial15)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial16)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial17)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial18)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial19)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial20)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial21)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial22)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial23)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial24)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial25)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial26)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.398438 6.820312 18.421875 7.726562 C 18.46875 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 17.828125 5.230469 C 17.664062 5.230469 17.5 5.25 17.347656 5.289062 C 17.808594 6.046875 18.347656 6.820312 18.371094 7.726562 C 18.417969 9.160156 16.75 10.144531 15.535156 9.378906 C 15.101562 11.203125 13.714844 15.15625 12.578125 12.089844 C 12.027344 10.457031 11.851562 9.324219 11.40625 7.808594 C 10.160156 2.484375 5.109375 1.78125 2.730469 5.289062 C 3.660156 5.507812 4.152344 6.394531 4.167969 7.296875 C 4.28125 8.257812 4.464844 9.195312 4.730469 10.121094 C 6.261719 5.414062 7.171875 6.617188 7.890625 9.550781 C 8.585938 12.515625 9.375 15.59375 11.355469 16.492188 C 13.960938 17.894531 16.824219 16.441406 17.921875 13.953125 C 18.761719 12.296875 19.261719 10.503906 19.550781 8.675781 C 19.636719 7.945312 19.871094 7.171875 19.621094 6.453125 C 19.34375 5.730469 18.597656 5.222656 17.828125 5.230469 Z M 17.828125 5.230469 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebex);
export default __webpack_public_path__ + "static/media/webex.8368eefbb8668d2e0c9ef87fe4f467ea.svg";
export { ForwardRef as ReactComponent };